module.exports = __webpack_public_path__ + "img/inspiration_04@2x.c4b52de.webp";